import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Save, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function LogoSettings() {
  const [logo, setLogo] = useState({ text: "", subtitle: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settings/logo").then((r) => setLogo(r.data.logo || { text: "", subtitle: "" })).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    try {
      await api.put("/settings/logo", logo);
      toast.success("Logo aggiornato");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  if (loading) return <div className="p-4 text-slate-500">Caricamento…</div>;

  return (
    <div className="space-y-4" data-testid="logo-settings-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">Logo aziendale</h1>
        <p className="text-slate-500 text-sm mt-1">Visualizzato nel foglio di giro stampabile</p>
      </div>

      <Card className="p-5 bg-white border border-slate-200 shadow-sm space-y-4">
        <div>
          <Label>Nome azienda *</Label>
          <Input value={logo.text} onChange={(e) => setLogo({ ...logo, text: e.target.value })} placeholder="Es. FirenzeWeb Olio Esausto" data-testid="logo-text-input" />
        </div>
        <div>
          <Label>Sottotitolo</Label>
          <Input value={logo.subtitle} onChange={(e) => setLogo({ ...logo, subtitle: e.target.value })} placeholder="Es. Servizio ritiro oli alimentari" data-testid="logo-subtitle-input" />
        </div>

        {/* Preview */}
        <div className="border-t pt-4">
          <div className="text-xs uppercase font-semibold text-slate-500 mb-2">Anteprima</div>
          <div className="flex items-center gap-3 p-4 border-2 border-[#1B5E20] rounded-lg bg-slate-50">
            <div className="h-12 w-12 rounded-lg bg-[#1B5E20] text-white flex items-center justify-center font-bold text-xl" style={{ fontFamily: "Outfit, sans-serif" }}>
              {(logo.text || "OE").charAt(0).toUpperCase()}
            </div>
            <div>
              <div className="font-bold text-[#1B5E20] text-lg" style={{ fontFamily: "Outfit, sans-serif" }}>{logo.text || "Foglio di giro"}</div>
              <div className="text-xs text-slate-500">{logo.subtitle || "—"}</div>
            </div>
            <ImageIcon size={20} className="ml-auto text-slate-300" />
          </div>
        </div>
      </Card>

      <Button onClick={save} disabled={!logo.text} className="w-full h-12 bg-[#1B5E20] hover:bg-[#144818] text-white" data-testid="save-logo-btn">
        <Save size={16} className="mr-2" /> Salva logo
      </Button>
    </div>
  );
}
